import { oc } from "@orpc/contract";
import { z } from "zod";

const TranslationRefreshReportSchema = z.object({
  customerName: z.string(),
  customerOriginId: z.string(),
  famousRowCount: z.number(),
  created: z.number(),
  updated: z.number(),
});

const refreshTranslationList = oc
  .input(
    z.object({
      customerId: z.string().uuid().optional(),
      stagedPurchaseOrderId: z.string().uuid().optional(),
    }),
  )
  .output(z.object({ reports: z.array(TranslationRefreshReportSchema) }));

export const famousContracts = {
  refreshTranslationList,
} as const;

export type FamousContracts = typeof famousContracts;

export type TranslationRefreshReport = z.infer<
  typeof TranslationRefreshReportSchema
>;
